import React from 'react';
import FinishSetUp from '../../Teacher/components/accounts/finish_set_up/finish_set_up';

export default props => (
  <FinishSetUp {...props} />
);
